import { useEffect } from 'react';

const CleanUrls = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // クリーニング対象のパラメータを定義
      const paramsToClean = ['yclid=', 'gclid=', 'fbclid=', 'utm_', 'teamid=', 'SD=', 'am_force_theme_layout=', 'SD', 's=', 'a8=', 'next_url='];

      // いずれかのパラメータを含むかチェック
      const hasParamsToClean = paramsToClean.some((param) => window.location.search.includes(param));

      if (hasParamsToClean) {
        // 現在のURLからクエリパラメータを除去したクリーンURLを作成
        const cleanUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

        // 現在のURLとクリーンURLが異なる場合のみ処理を実行
        if (window.location.href !== cleanUrl) {
          // Google Analytics や Google Tag Manager がパラメータを処理する時間を確保
          // 通常は数百ミリ秒で十分
          setTimeout(() => {
            // 履歴を書き換えるが、ページはリロードしない（replaceState）
            window.history.replaceState({}, document.title, cleanUrl);

            // デバッグ用（必要に応じてコメント解除）
            // console.log('URL cleaned:', cleanUrl);
          }, 800); // 800ミリ秒後に実行（トラッキングツールの処理時間をより確保）
        }
      }
    }
  }, []);

  // このコンポーネントは可視要素を描画しない
  return null;
};

export default CleanUrls;
